import React, { useState, useEffect } from "react";
import BusinessList from "../../components/common/BusinessList";
import CardHeader from "../../components/common/CardHeader";

function Businesses() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarVisible(true);
    } else {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    //handleResize(); // Wywołanie przy montowaniu komponentu

    return () => window.removeEventListener("resize", handleResize); // Oczyszczenie przy demontowaniu
  }, []);

  return (
    <>
      <CardHeader text="Powiązane firmy" onlyText="true" />
      <BusinessList />
    </>
  );
}

export default Businesses;
